import React from 'react';
import { Tooltip } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { ListItemText, ItemList, Icon } from './styles';

type DrawerListProps = {
  tag: string;
  label: string;
  color: string;
  readers?: string[] | null;
  backgroundColor?: string;
  title?: boolean;
  disabled?: boolean;
  setDrawerOpen: (open: boolean) => boolean;
};

const DrawerList: React.FC<DrawerListProps> = ({
  tag,
  label,
  color,
  readers,
  title,
  setDrawerOpen,
  disabled,
}) => {
  const history = useHistory();

  const goTo = (to: string) => {
    history.push(to);
    setDrawerOpen(false);
  };

  const getIcon = () => {
    if (label === 'Home') return 'bx bx-home';
    if (title) return '';
    if (disabled) return '';
    return 'bx bx-cube';
  };

  if (label === 'Home') {
    return (
      <ItemList
        button
        onClick={() => {
          history.push('/');
          setDrawerOpen(false);
        }}
        isTitle={title}
        isDisabled={disabled}
      >
        <Icon className={getIcon()} />
        <ListItemText
          color={color}
          primary={label}
        />
      </ItemList>
    );
  }

  return (
    <ItemList
      button
      onClick={() => goTo(`/${tag}/list`)}
      disabled={disabled}
      isTitle={title}
      isDisabled={disabled}
    >
      {readers && !title ? (
        <Tooltip
          title={`Reader orgs: ${readers
            .map((org) => org.replace('MSP', ''))
            .join(' ')}`}
        >
          <Icon className="bx bx-lock-alt" />
        </Tooltip>
      ) : (
        <Icon className={getIcon()} />
      )}
      <ListItemText
        color={color}
        primary={label}
      />
    </ItemList>
  );
};

export default DrawerList;